import type { PostHogConfig } from 'posthog-js';
import env from '~/env';
import { POSTHOG_INGEST_ORIGIN, POSTHOG_INGEST_ORIGIN_DIRECT, POSTHOG_UI_HOST } from './constants';

export const _POSTHOG_SHARED_CONFIG = {
    ENABLED: env.NEXT_PUBLIC_POSTHOG_ENABLED === true,
    /**
     * When true, raw user comments + full conversation transcripts are included
     * in the `$ai_feedback` observability event. When false (default) only
     * structural metadata (reasons, has_comment, conversation_length) is sent.
     * Flip via env in production once consent/legal has signed off.
     */
    CAPTURE_AI_FEEDBACK_TEXT: env.NEXT_PUBLIC_POSTHOG_CAPTURE_AI_FEEDBACK_TEXT === true,
    /**
     * Deploy environment tag attached to every AI event/trace so LLM
     * observability can be filtered to `production` only (dev/preview/local
     * noise stays out of prod analytics). Reads the public Vercel env var so
     * the same value is available on both the server and the browser.
     */
    ENVIRONMENT: env.NEXT_PUBLIC_VERCEL_ENV,
    /** Host for the analytics endpoint (browser → reverse-proxied via Next.js rewrites) */
    HOST: POSTHOG_INGEST_ORIGIN,
    /** Direct PostHog ingest host (server-side, no proxy) */
    HOST_DIRECT: POSTHOG_INGEST_ORIGIN_DIRECT,
    /** PostHog UI host (toolbar, links) */
    UI_HOST: POSTHOG_UI_HOST,

    /** Enable caching for fetching feature flags etc */
    FETCH_OPTIONS: {
        cache: 'force-cache', // Use Next.js cache
        next_options: {
            // Passed to the `next` option for `fetch`
            revalidate: 60, // Cache for 60 seconds
            tags: ['posthog'], // Can be used with Next.js `revalidateTag` function
        },
    } satisfies PostHogConfig['fetch_options'],
} as const;
